import { EVENT_CLICK_ACCESSORY } from '~~/constants/googleTagManager';
import type { EcommerceClickAccessory } from '~~/types/integrations/tagManager/TagClickAccessory';

export const buildClickAccessoryTags = (productSku: string, parentProductSku: string) => ({
  event: EVENT_CLICK_ACCESSORY,
  ecommerce: {
    detail: {
      items: {
        parent_product_id: parentProductSku,
        accessory_id: productSku,
      },
    },
  } as EcommerceClickAccessory,
});
